module.exports = __webpack_public_path__ + "img/capac_olavarria.3841fe44.jpg";